module.exports = __webpack_public_path__ + "static/dots-8566c7cf004c292012d8495e1614ac9d.jpg";